import { render, staticRenderFns } from "./IncDocEmail.vue?vue&type=template&id=42fcf8eb&"
import script from "./IncDocEmail.vue?vue&type=script&lang=js&"
export * from "./IncDocEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports